import { render, staticRenderFns } from "./articleCategoryList.vue?vue&type=template&id=132ce018&scoped=true&"
import script from "./articleCategoryList.vue?vue&type=script&lang=js&"
export * from "./articleCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./articleCategoryList.vue?vue&type=style&index=0&id=132ce018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ce018",
  null
  
)

export default component.exports